import React from 'react';
import './Terms.css';

const Terms: React.FC = () => {
  return (
    <div className="terms-page">
      <div className="container">
        <div className="terms-header">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: October 19, 2025</p>
        </div>

        <div className="terms-content">
          <section className="terms-section">
            <h2>1. Agreement to Terms</h2>
            <p>
              These Terms of Service ("Terms") constitute a legally binding agreement between you and Baseline Racquets Consultants of America ("Company," "we," "us," or "our") concerning your access to and use of our website and services.
            </p>
            <p>
              By accessing or using our website, you agree that you have read, understood, and agree to be bound by these Terms. If you do not agree to these Terms, you are prohibited from using or accessing our website and services.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Intellectual Property Rights</h2>
            <p>
              Unless otherwise indicated, our website and all content, features, and functionality (including but not limited to all information, software, text, displays, images, video, and audio) are owned by Baseline Racquets Consultants of America, its licensors, or other providers of such material and are protected by United States and international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
            </p>
            <p>
              You are permitted to use our website and services for your personal, non-commercial use only. You must not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our website without our prior written consent.
            </p>
          </section>

          <section className="terms-section">
            <h2>3. User Representations</h2>
            <p>By using our services, you represent and warrant that:</p>
            <ul>
              <li>All registration information you submit will be true, accurate, current, and complete</li>
              <li>You will maintain the accuracy of such information and promptly update such registration information as necessary</li>
              <li>You have the legal capacity and you agree to comply with these Terms</li>
              <li>You are not a minor in the jurisdiction in which you reside</li>
              <li>You will not access our services through automated or non-human means</li>
              <li>You will not use our services for any illegal or unauthorized purpose</li>
              <li>Your use of our services will not violate any applicable law or regulation</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>4. Prohibited Activities</h2>
            <p>You may not access or use our services for any purpose other than that for which we make them available. Prohibited activities include, but are not limited to:</p>
            <ul>
              <li>Systematic retrieval of data or other content to create or compile a collection, database, or directory without written permission</li>
              <li>Making any unauthorized use of our services, including collecting usernames and/or email addresses by electronic or other means</li>
              <li>Circumventing, disabling, or otherwise interfering with security-related features</li>
              <li>Engaging in unauthorized framing of or linking to our website</li>
              <li>Tricking, defrauding, or misleading us and other users</li>
              <li>Interfering with, disrupting, or creating an undue burden on our services or networks</li>
              <li>Attempting to impersonate another user or person</li>
              <li>Selling or transferring your user account</li>
              <li>Using our services to advertise or offer to sell goods and services</li>
              <li>Uploading or transmitting viruses, Trojan horses, or other malicious material</li>
              <li>Harassing, annoying, intimidating, or threatening any of our employees or agents</li>
              <li>Copying or adapting our website's software or any portion thereof</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>5. User Generated Content</h2>
            <p>
              Our services may allow you to submit, post, display, or transmit content, including but not limited to text, images, or other materials ("User Content"). You retain all rights in, and are solely responsible for, the User Content you submit.
            </p>
            <p>
              By submitting User Content, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, adapt, publish, translate, distribute, and display such content in connection with operating and providing our services.
            </p>
            <p>
              You represent and warrant that your User Content does not violate any third-party rights, including intellectual property rights, privacy rights, or any applicable laws.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. Services and Pricing</h2>
            <p>
              We reserve the right to change our services, pricing, and any fees at any time. We will provide notice of any changes to pricing or services as required by law. Your continued use of our services after such changes constitutes your acceptance of the new terms.
            </p>
            <p>
              All fees are quoted in U.S. dollars unless otherwise stated. Payment is due as specified in the applicable invoice or agreement. Late payments may result in suspension or termination of services.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. Cancellation and Refunds</h2>
            <p>
              You may cancel your account or services at any time by contacting us. Refund policies vary depending on the specific service and will be outlined in your service agreement or invoice.
            </p>
            <p>
              We reserve the right to refuse service, terminate accounts, or cancel orders at our sole discretion, including but not limited to situations where we believe user conduct violates applicable law or is harmful to our interests.
            </p>
          </section>

          <section className="terms-section">
            <h2>8. Disclaimers</h2>
            <p>
              OUR SERVICES ARE PROVIDED ON AN "AS-IS" AND "AS-AVAILABLE" BASIS. WE MAKE NO WARRANTIES, EXPRESSED OR IMPLIED, AND HEREBY DISCLAIM AND NEGATE ALL OTHER WARRANTIES, INCLUDING WITHOUT LIMITATION, IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT OF INTELLECTUAL PROPERTY OR OTHER VIOLATION OF RIGHTS.
            </p>
            <p>
              We do not warrant that our services will be uninterrupted, timely, secure, or error-free. We do not warrant that the results obtained from the use of our services will be accurate or reliable. You understand that we cannot and do not guarantee that files available for download will be free of viruses or other destructive code.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Limitations of Liability</h2>
            <p>
              IN NO EVENT SHALL BASELINE CONSULTING, NOR ITS DIRECTORS, EMPLOYEES, PARTNERS, AGENTS, SUPPLIERS, OR AFFILIATES, BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM:
            </p>
            <ul>
              <li>Your access to or use of or inability to access or use our services</li>
              <li>Any conduct or content of any third party on our services</li>
              <li>Any content obtained from our services</li>
              <li>Unauthorized access, use, or alteration of your transmissions or content</li>
            </ul>
            <p>
              Our total liability to you for all claims arising out of or relating to these Terms or our services shall not exceed the amount you paid to us, if any, in the twelve (12) months preceding the claim.
            </p>
          </section>

          <section className="terms-section">
            <h2>10. Indemnification</h2>
            <p>
              You agree to defend, indemnify, and hold harmless Baseline Racquets Consultants of America and its affiliates, licensors, and service providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors, and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your violation of these Terms or your use of our services.
            </p>
          </section>

          <section className="terms-section">
            <h2>11. Governing Law and Dispute Resolution</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the United States and the State in which Baseline Racquets Consultants of America is registered, without regard to its conflict of law provisions.
            </p>
            <p>
              Any disputes arising out of or relating to these Terms or our services shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association. The arbitration shall take place in the same state where Baseline Racquets Consultants of America is registered. Each party shall bear its own costs and expenses.
            </p>
          </section>

          <section className="terms-section">
            <h2>12. Privacy Policy</h2>
            <p>
              Your use of our services is also governed by our Privacy Policy. Please review our Privacy Policy to understand our practices regarding the collection, use, and disclosure of your personal information.
            </p>
          </section>

          <section className="terms-section">
            <h2>13. Termination</h2>
            <p>
              We may terminate or suspend your account and access to our services immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms.
            </p>
            <p>
              Upon termination, your right to use our services will immediately cease. All provisions of these Terms which by their nature should survive termination shall survive, including ownership provisions, warranty disclaimers, indemnity, and limitations of liability.
            </p>
          </section>

          <section className="terms-section">
            <h2>14. Severability</h2>
            <p>
              If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law, and the remaining provisions will continue in full force and effect.
            </p>
          </section>

          <section className="terms-section">
            <h2>15. Entire Agreement</h2>
            <p>
              These Terms, together with our Privacy Policy and any other legal notices published by us on our services, shall constitute the entire agreement between you and Baseline Racquets Consultants of America concerning our services.
            </p>
          </section>

          <section className="terms-section">
            <h2>16. Changes to These Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
            </p>
            <p>
              By continuing to access or use our services after any revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, you are no longer authorized to use our services.
            </p>
          </section>

          <section className="terms-section">
            <h2>17. Contact Information</h2>
            <p>If you have any questions about these Terms, please contact us at:</p>
            <div className="contact-info">
              <p><strong>Baseline Racquets Consultants of America</strong></p>
              <p>Email: legal@baselineconsulting.org</p>
            </div>
          </section>

          <section className="terms-acknowledgment">
            <p>
              <strong>BY USING OUR SERVICES, YOU ACKNOWLEDGE THAT YOU HAVE READ THESE TERMS OF SERVICE AND AGREE TO BE BOUND BY THEM.</strong>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;

